import {nombreDeAcciones} from 'constantes/index';
const mapDispatchToProps = dispatch => ({ 
    SET_MENU_ITEM_GROUP: (index)=> dispatch(
        {   "type":nombreDeAcciones.SET_MENU_ITEM_GROUP,
            "state":{"index":index} 
        }
    )
});
export default mapDispatchToProps;